/*
  When the customer changes Frame/Color, if the currently-selected Format
  is not offered under the new frame (shows disabled), auto-select the
  first available Format instead of leaving a dead selection checked.

  This is the real fix for the "Compact XL reads as sold out" class of bug
  (Retro Finder, Ultra Violet, Siren — 2026-09) — the picker no longer
  requires the shopper to notice and manually recover from an invalid combo.

  Dawn's product-info.js replaces the whole <variant-selects> element after
  its fetch resolves (HTMLUpdateUtility.viewTransition), so this waits for
  that DOM swap via MutationObserver rather than guessing a timeout.
*/
(function () {
  if (window.__cxcAutoFormatBound) return;
  window.__cxcAutoFormatBound = true;

  function findFieldsetByKeyword(root, keywords) {
    var fieldsets = root.querySelectorAll('fieldset');
    for (var i = 0; i < fieldsets.length; i++) {
      var legend = fieldsets[i].querySelector('legend');
      var txt = (legend ? legend.textContent : '').toLowerCase();
      for (var k = 0; k < keywords.length; k++) {
        if (txt.indexOf(keywords[k]) > -1) return fieldsets[i];
      }
    }
    return null;
  }

  function correctFormatIfNeeded(variantSelects) {
    var formatFieldset = findFieldsetByKeyword(variantSelects, ['format', 'layout']);
    if (!formatFieldset) return;
    var checked = formatFieldset.querySelector('input:checked');
    if (!checked || !checked.classList.contains('disabled')) return;
    var firstAvailable = formatFieldset.querySelector('input:not(.disabled)');
    if (!firstAvailable || firstAvailable === checked) return;
    firstAvailable.checked = true;
    firstAvailable.dispatchEvent(new Event('change', { bubbles: true }));
  }

  document.addEventListener('change', function (e) {
    var target = e.target;
    var variantSelects = target.closest && target.closest('variant-selects');
    if (!variantSelects) return;

    var optionName = (target.dataset.optionName || '').toLowerCase();
    var isFrameChange = optionName.indexOf('frame') > -1 || optionName === 'color';
    if (!isFrameChange) return;

    var parent = variantSelects.parentNode;
    if (!parent) return;

    var observer = new MutationObserver(function (mutations, obs) {
      obs.disconnect();
      var newVariantSelects = parent.querySelector('variant-selects');
      if (newVariantSelects) correctFormatIfNeeded(newVariantSelects);
    });
    observer.observe(parent, { childList: true });
    // Safety timeout in case no swap happens (e.g. the combo is genuinely
    // unavailable site-wide and product-info.js takes the setUnavailable() path).
    setTimeout(function () { observer.disconnect(); }, 3000);
  });
})();
